// Is the viewport phone-sized? Used to swap the transactions TABLE for a
// card list on small screens (a table can't be honestly responsive — we
// render one layout or the other, never both hidden-by-CSS, so tests and
// screen readers see a single source of truth).
import { useState, useEffect } from 'react'

const QUERY = '(max-width: 767px)' // below Tailwind's md breakpoint

export function useIsMobile() {
  const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
  const [isMobile, setIsMobile] = useState(() => (supported ? window.matchMedia(QUERY).matches : false))

  useEffect(() => {
    if (!supported) return undefined
    const mql = window.matchMedia(QUERY)
    const onChange = (e) => setIsMobile(e.matches)
    // Older Safari uses addListener/removeListener.
    if (mql.addEventListener) mql.addEventListener('change', onChange)
    else if (mql.addListener) mql.addListener(onChange)
    setIsMobile(mql.matches)
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange)
      else if (mql.removeListener) mql.removeListener(onChange)
    }
  }, [supported])

  return isMobile
}
